<template>
    <div class="w-full h-full overflow-hidden">
        <div class="text-center">
            <img v-if="logo && show" :src="logo" :alt="name"
                 :style="{'max-width': width, 'max-height': height}"
                 class="mx-auto" @error="show=false">

            <span v-else class="text-sm text-center">
                {{ name }}
            </span>
        </div>
    </div>
</template>

<script>

export default {
    name: "Logo",
    props: {
        width: {
            type: String,
            default: 'auto'
        },
        height: {
            type: String,
            default: 'auto'
        }
    },

    data() {
        return {
            name: window.appConfig.dash.name,
            logo: window.appConfig.dash.logo,
            show: true
        }
    },

    methods: {

        errorOnLoad() {
            console.error('error on load logo')
            this.show = false;
        }
    }
}
</script>

<style scoped>

</style>